// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles = [], children }) => {
    const userRole = localStorage.getItem('role');

    // If user is not logged in
    if (!userRole) {
        return <Navigate to="/" replace />;
    }

    // If user doesn't have permission
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/home" replace />;
    }

    // User is authorized
    return typeof children === 'function' ? children() : children;
};

export default ProtectedRoute;
